import { Flex, Spinner } from '@vimeo/bokeh';

export default function LoadingPage() {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100vw"
      height="100vh"
      bgColor="background"
    >
      <Spinner size="xl" />
    </Flex>
  );
}
